module.exports = __webpack_public_path__ + "img/sr.31be3ebe.svg";